import React, { memo, FC } from 'react';
import { RichText } from '@montana/shared/rich-text';
import { Media, MontanaMediaRatios } from '@montana/shared/media';
import { IUSP } from '@montana/models/generated/cms.interface';

interface IUspProps {
    usp: IUSP;
}

export const Usp: FC<IUspProps> = memo((props: IUspProps) => {
    const { usp } = props;

    return (
        <div className="usp">
            <div className="usp__heading">
                {usp.uspIcon && <Media className="usp__image" image={usp.uspIcon} mediaRatio={MontanaMediaRatios.Square} placeholder={false} />}
                <RichText text={usp.uspHeading || ''} />
            </div>
            <RichText text={usp.uspText || ''} />
        </div>
    );
});
